import { sentryHub } from './sentryClient.tsx';
import pkg from '../../package.json';

// https://blog.sentry.io/trace-errors-through-stack-using-unique-identifiers-in-sentry/#1-generate-a-unique-identifier-and-set-it-as-a-sentry-tag-on-issuing-service
export const generateSentryTransactionId = () => {
  return Math.random().toString(36).substr(2, 9);
};

type SentryCaptureExceptionWithScopeType = {
  requestOperationKind?: string;
  requestName?: string;
  sentryTransactionId?: string;
  error: string | string[] | Error | Error[];
};
export const sentryCaptureExceptionWithScope = ({
  requestOperationKind,
  requestName,
  sentryTransactionId,
  error,
}: SentryCaptureExceptionWithScopeType) => {
  const setRequestOperationKind = (scope) => {
    if (requestOperationKind) {
      scope.setTag('request_operation_kind', requestOperationKind);
    }
  };

  const setRequestName = (scope) => {
    if (requestName) {
      scope.setTag('request_name', requestName);
    }
  };

  const setAppVersion = (scope) => {
    if (pkg.version) {
      scope.setTag('app_version', pkg.version);
    }
  };

  const setSentryTransactionId = (scope) => {
    if (sentryTransactionId) {
      scope.setTag('sentry_transaction_id', sentryTransactionId);
    }
  };

  setRequestOperationKind(sentryHub);
  setRequestName(sentryHub);
  setAppVersion(sentryHub);
  setSentryTransactionId(sentryHub);
  sentryHub.captureException(error);
};
